import type { Project } from '@/types';

export const projects: Project[] = [
  {
    id: 'nova-operativna-strategija',
    title: 'Operativni plan regionalnog tima',
    category: 'Planiranje projekta',
    description:
      'Usklađeni prioriteti, odgovornosti i mesečni plan rada za tri poslovne jedinice.',
    image:
      'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1400&q=85',
    imageAlt: 'Završen enterijer poslovnog projekta'
  },
  {
    id: 'digitalno-radno-okruzenje',
    title: 'Jedinstvena evidencija zadataka',
    category: 'Uređenje procesa',
    description:
      'Uveden zajednički pregled zadataka i odluka koji je zamenio više nepovezanih tabela.',
    image:
      'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1400&q=85',
    imageAlt: 'Svetao kancelarijski prostor digitalnog radnog okruženja'
  },
  {
    id: 'lansiranje-nove-usluge',
    title: 'Priprema nove usluge za tržište',
    category: 'Vođenje i koordinacija',
    description:
      'Koordinacija prodaje, operacija i eksternih saradnika od definisanja ponude do prvih klijenata.',
    image:
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=85',
    imageAlt: 'Detalj završenog savremenog enterijera'
  }
];
